import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { ServicePlanItemPricingPolicy } from 'src/features/servicePlanPricingPolicies/utils/types';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-pricing-policy/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    servicePlanItemId: string;
}

const queryFn = ({ servicePlanItemId, ...params }: DTO): Promise<ListResponseAPI<ServicePlanItemPricingPolicy>> => {
    return axios.get(formatResourcePath(RESOURCE, { servicePlanItemId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SERVICE_PLAN_PRICING_POLICIES_RESOURCE, useQueryHook as useListServicePlanPricingPolicies };
